import { useQuery } from "@apollo/react-hooks";
import { InlineError, Select, Stack } from "@shopify/polaris";
import { get } from "lodash";
import React, {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useState,
} from "react";
import { TEAM_USERS_BY_ROLE } from "../../graphql/queries";
import { arrInvalid } from "../../helper";
import { TEAM_ROLE } from "../../variable";
import AutocompleteV2 from "../shared/AutocompleteV2";
import { ComponentLabelPolaris } from "../shared/ComponentLabelPolaris";

function AmazonIdeaSupporter({ allowMultiple }, ref) {
    const [state, setState] = useState(allowMultiple ? [] : "");
    const [error, setError] = useState(null);

    const { data } = useQuery(TEAM_USERS_BY_ROLE, {
        variables: {
            role: TEAM_ROLE.ChannelSupporter,
        },
    });

    const getSupporter = useCallback(() => {
        if (!state) {
            setError("Supporter is required");
            return;
        }

        if (allowMultiple && arrInvalid(state)) {
            setError("Supporter is required");
            return;
        }

        return state;
    }, [state]);

    const handleStateChange = useCallback((selected) => {
        setState(selected);

        if (!selected) {
            setError("Supporter is required");
        } else {
            setError(null);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        getSupporter: getSupporter,
    }));

    return (
        <>
            <ComponentLabelPolaris label="Channel Supporter" required />
            {allowMultiple ? (
                <Stack vertical spacing="extraTight">
                    <AutocompleteV2
                        options={getUsers(data) || []}
                        onChange={handleStateChange}
                        allowMultiple
                    />
                    <InlineError message={error?.toString()} />
                </Stack>
            ) : (
                <Select
                    options={getUsers(data, true)}
                    value={state}
                    onChange={handleStateChange}
                    error={error}
                />
            )}
        </>
    );
}

function getUsers(data, isSelect) {
    const nodes = get(data, "teamUsersByRole") || [];

    const res = new Map();
    if (isSelect) {
        res.set("", { value: "", label: "Choose Supporter" });
    }
    for (let node of nodes) {
        if (!node || !node.id) continue;
        const fName = [node.firstName, node.lastName].filter(Boolean).join(" ");

        res.set(node.id, { value: node.id, label: fName });
    }

    return Array.from(res.values());
}

export default forwardRef(AmazonIdeaSupporter);
